import React from "react"
import { List, Text, Separator } from "native-base"
import I18n from "i18n"
import BookingListItem from "../BookingListItem"
import EmptyList from "components/views/Shared/EmptyList"
import _ from "lodash"
import styles from "./styles"
import { Navigation } from "components/types"

interface Props {
  offerIds: string[]
  navigation: Navigation
}

export default class BookingList extends React.Component<Props> {
  shouldComponentUpdate(nextProps: Props) {
    return !_.isEqual(nextProps.offerIds, this.props.offerIds)
  }

  render() {
    const { offerIds = [], navigation } = this.props
    return (
      <List style={styles.list}>
        <Separator style={styles.separator}>
          <Text style={styles.separatorText}>
            {I18n.t("title_upcoming_jobs").toUpperCase()}
          </Text>
        </Separator>
        {offerIds.length ? (
          offerIds.map((item, idx) => (
            <BookingListItem
              last={offerIds.length === idx + 1}
              key={`offer_accepted_list_item_${item}`}
              id={item}
              navigation={navigation}
            />
          ))
        ) : (
          <EmptyList emptyTextMessage={I18n.t("empty_accepted_offer_list")} />
        )}
      </List>
    )
  }
}
